import { render, staticRenderFns } from "./TheProducts.vue?vue&type=template&id=39e860e6&scoped=true&"
import script from "./TheProducts.vue?vue&type=script&lang=js&"
export * from "./TheProducts.vue?vue&type=script&lang=js&"
import style0 from "./TheProducts.vue?vue&type=style&index=0&id=39e860e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e860e6",
  null
  
)

export default component.exports